import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuItemStatusSchema, UpdateMenuItemStatusRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const schema = UpdateMenuItemStatusRequestSchema.strict()

const normalize = fieldNormalizer({
  enums: [{ field: 'status', options: MenuItemStatusSchema.options }]
})

export const MenuItemUpdateStatus = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
